import { HTMLChakraProps, forwardRef } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

import { useThinkingContext } from '../ThinkingContext';
import { useThinkingStyles } from '../useThinkingStyles';

export type ThinkingExpandButtonProps = HTMLChakraProps<'button'>;

export const ThinkingExpandButton: React.FC<ThinkingExpandButtonProps> =
  forwardRef<ThinkingExpandButtonProps, 'p'>(({ children, ...props }, ref) => {
    const { expandButton } = useThinkingStyles();
    const { isExpanded, isThinking, isToggleExpansionDisabled, setIsExpanded } =
      useThinkingContext();

    return (
      <chakra.button
        sx={expandButton}
        className="thinking-expand-button"
        onClick={
          !isToggleExpansionDisabled
            ? () => setIsExpanded(!isExpanded)
            : undefined
        }
        // Apply attributes in relevant states to connect to styles.
        data-thinking={isThinking}
        data-can-expand={!isToggleExpansionDisabled}
        {...props}
        ref={ref}
      >
        {children}
      </chakra.button>
    );
  });
